<template>
  <a-row :gutter="24" :visible="visible" >
    <a-col :md="24">
      <a-card :style="cardStyle1" :bordered="false">
        <!-- table区域-begin -->
        <div>
          <a class="productLicense">商品证照：</a>
          <a-table ref="table" size="middle" bordered rowKey="uuid"
            :columns="columns" :dataSource="dataSource" :components="handleDrag(columns)"
            :pagination="ipagination" :loading="loading"
            style="word-break: break-all;">
            <span slot="action" slot-scope="text, record">
              <a type="primary" @click="handleProductEdit(record,0)">编辑</a>
              <a-divider type="vertical" />
              <a type="primary" @click="handleDelete(record)">删除</a>
            </span>
            <template slot="createTime" slot-scope="createTime">
              <span>{{changetime(createTime)}}</span>
            </template>
            <template slot="state" slot-scope="state">
              <a-tag v-if="state === 0" color="blue">待审核</a-tag>
              <a-tag v-else-if="state === 1" color="blue">审核中</a-tag>
              <a-tag v-else-if="state === 2" color="green">审核通过</a-tag>
              <a-tag v-else-if="state === 3" color="red">未通过</a-tag>
            </template>
            <template slot="licenseType" slot-scope="licenseType">
              <a-tag v-if="licenseType == 0" color="blue">经营许可证</a-tag>
              <a-tag v-else-if="licenseType == 1" color="blue">生产许可证</a-tag>
              <a-tag v-else-if="licenseType == 2" color="green">产品注册证</a-tag>
            </template>
            <template slot="customPic" slot-scope="text, record">
                <a-popover placement="right" trigger="click">
                    <template slot="content">
                    <img :src="getImgUrl(record.attachment, record.imgLarge)" width="500px" />
                    </template>
                    <div style="width:52px;height:52px;" v-if="record.attachment">
                    <img v-if="record.attachment" :src="getImgUrl(record.attachment, record.imgSmall)" class="item-img" title="查看大图" style="width:100%;height:auto"/>
                    </div>
                </a-popover>
            </template>
          </a-table>
        </div>
        <!-- table区域-end -->
        <!-- 生产企业证照table区域-begin -->
        <div>
          <a class="productLicense">生产企业证照：</a>
          <a-table ref="table" size="middle" bordered rowKey="uuid"
            :columns="supperColumns" :dataSource="dataSource2" :components="handleDrag(columns)"
            :pagination="ipagination" :loading="loading"
            style="word-break: break-all;">
            <span slot="action" slot-scope="text, record">
              <a type="primary" @click="handleManufactureEdit(record,1)">编辑</a>
              <a-divider type="vertical" />
              <a type="primary" @click="handleManufactureDelete(record)">删除</a>
            </span>
            <template slot="createTime" slot-scope="createTime">
              <span>{{changetime(createTime)}}</span>
            </template>
            <template slot="state" slot-scope="state">
              <a-tag v-if="state === 0" color="blue">待审核</a-tag>
              <a-tag v-else-if="state === 1" color="blue">审核中</a-tag>
              <a-tag v-else-if="state === 2" color="green">审核通过</a-tag>
              <a-tag v-else-if="state === 3" color="red">未通过</a-tag>
            </template>
            <template slot="productLicenseType" slot-scope="licenseType">
              <a-tag v-if="licenseType == 0" color="blue">营业执照</a-tag>
            </template>
            <template slot="customPic" slot-scope="text, record">
                <a-popover placement="right" trigger="click">
                    <template slot="content">
                    <img :src="getImgUrl(record.attachment, record.imgLarge)" width="500px" />
                    </template>
                    <div style="width:52px;height:52px;" v-if="record.attachment">
                    <img v-if="record.attachment" :src="getImgUrl(record.attachment, record.imgSmall)" class="item-img" title="查看大图" style="width:100%;height:auto"/>
                    </div>
                </a-popover>
            </template>
          </a-table>
        </div>
        <!-- 生产企业证照table区域-end -->
        <!-- 表单区域 -->
        <!-- 商品证照 -->
        <productLisenceDetail ref="productLisenceModal" @ok="modalFormOk" @close="modalFormClose"></productLisenceDetail>
        <addProductLicense ref="modalForm" @ok="modalFormOk" @close="modalFormClose" :productId="this.productId"></addProductLicense>
        <addLicense ref="modalLicense" @ok="modalLicenseOk" @close="modalLicenseClose"></addLicense>
      </a-card>
    </a-col>
  </a-row>
</template>
<!-- create ji sheng hua-->
<script>
//productLisenceDetail
import productLisenceDetail from './productLisenceDetail'
import addProductLicense from './addProductLicense'
import addLicense from './addLicense'
import { campListMixins } from '../mixins/campListMixins'
import { postAction, getFileAccessHttpUrl } from '@/api/manage'
import { licenseDelete,ManufactureLicenseDelete } from '@/api/api'
import JDate from '@/components/jeecg/JDate'


export default {
  name: 'RetailOutList',
  mixins: [campListMixins],
  components: {
    productLisenceDetail,
    addProductLicense,
    addLicense,
    JDate,
  },
  props:{
    productInfo: {
      type: Object,
      default: {}
    }},
  data() {
    return {
      ipagination: {
        pageSizeOptions: ['10', '20', '30', '100', '200'],
      },
      productId: '',
      // dataSource: [],
      visible: false,
      editingRow: null,
      // 查询条件
      queryParam: {
        // page: 1,
        // limit: 20,
        // keywords: '',
        // specification: '',
        // codeSystem:''
      },
      prefixNo: 'LSCK',
      labelCol: {
        span: 5,
      },
      wrapperCol: {
        span: 18,
        offset: 1,
      },
      // 默认列
      columns: [
        { title: '序号', dataIndex: 'index', width: 50, customRender:(text,record,index) =>`${index + 1}`},
        { title: '证照类型', dataIndex: 'licenseType', width: 100, scopedSlots: { customRender: 'licenseType' } , render: (text) => text || "--" },
        { title: '证照编码', dataIndex: 'licenseCode',width: 120, render: (text) => text || "--"},
        { title: '有效期起', dataIndex: 'expirationDate', width: 120, render: (text) => text || "--" },
        { title: '有效期至', dataIndex: 'expirationEndDate', width: 120 ,ellipsis: true, render: (text) => text || "--" },
        { title: '附件', dataIndex: 'attachment',width: 80, align: "center",scopedSlots: { customRender: 'customPic' } },
        // {
        //   title: '操作',
        //   dataIndex: 'action',
        //   align: 'center',
        //   width: 140,
        //   scopedSlots: { customRender: 'action' },
        // },
      ],
      supperColumns: [
        { title: '序号', dataIndex: 'index', width: 50, customRender:(text,record,index) =>`${index + 1}`},
        // { title: '状态', dataIndex: 'state',width: 80, align: "center",scopedSlots: { customRender: 'state' } },
        { title: '证照类型', dataIndex: 'licenseType', width: 100, scopedSlots: { customRender: 'productLicenseType' } , render: (text) => text || "--" },
        { title: '证照编码', dataIndex: 'licenseCode',width: 120, render: (text) => text || "--"},
        { title: '有效期起', dataIndex: 'expirationDate', width: 120, render: (text) => text || "--" },
        { title: '有效期至', dataIndex: 'expirationEndDate', width: 120 ,ellipsis: true, render: (text) => text || "--" },
        { title: '附件', dataIndex: 'attachment',width: 80, align: "center",scopedSlots: { customRender: 'customPic' } },
        // {
        //   title: '操作',
        //   dataIndex: 'action',
        //   align: 'center',
        //   width: 140,
        //   scopedSlots: { customRender: 'action' },
        // },
      ],
      // url: {
      //   list: '/sy/material/materialLicence/list',

      // },
    }
  },
  computed: {},
  created() {
    console.log(this.productInfo,'=======================55555555555555================')
    this.dataSource = this.productInfo.materialLicences
    this.dataSource2 = this.productInfo.supplierLicences
  },
  methods: {
    initShow(e,num){
      console.log(e,num,'=======================从审核页面过来的========')
      this.dataSource = e.materialLicences
      this.dataSource2 = e.supplierLicences
      this.productId = num
    },
    handleProductEdit: function (record,num) {
       this.$refs.modalForm.edit(record,num)
       this.$refs.modalForm.title = "编辑"
       console.log(this,'==================this.$refs===============')
       this.$refs.modalForm.disableSubmit = false
    },
    handleEdit: function (record,num) {
       this.$refs.modalForm.edit(record,num)
       this.$refs.modalForm.title = "编辑"
       this.$refs.modalForm.disableSubmit = false
     },
    changetime(createTime) {
      return createTime.replace('T', ' ')
    },
    //商品证照删除
    async handleDelete(record) {
      let params = {
        id : record.uuid
      }
      const res = await licenseDelete(params)
      if (res.code == 200 && res.success == true) {
        this.$message.success(res.message)
        this.dataSource = this.dataSource.filter(row => row !== record);
      } else {
        this.$message.error(res.message)
      }
      this.visible = false
      this.loadData()
    },
    modalFormClose(){
      // this.
    },
    //企业证照删除
    async handleManufactureDelete(record) {
      let params = {
        id : record.uuid
      }
      const res = await ManufactureLicenseDelete(params)
      if (res.code == 200 && res.success == true) {
        this.$message.success(res.message)
        this.dataSource = this.dataSource2.filter(row => row !== record);
        this.visible = false
      } else {
        this.$message.error(res.message)
      }
      this.visible = false
    },
    getImgUrl (imgName, type) {
      if (imgName && imgName.split(',')) {
        type = type ? type + '/' : ''
        return getFileAccessHttpUrl('systemConfig/static/' + type + imgName.split(',')[0])
      } else {
        return ''
      }
    },
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
/deep/.ant-table-row-cell-break-word:empty:after {
    content: '--';
  }
  .productLicense {
    display: block;
    padding: 2px 5px;
    margin: 5px 0 15px 0;
    border-left: 3px solid #1890FF;
  }
</style>